import { addDoc, collection, getFirestore } from "firebase/firestore";
import { userUserStore } from "../stores/user";
import type { ApiFixedClienteVenta } from "./cloudFunctions/fixed/apiFixedVenta";

export type ClienteFirestoreDoc = ApiFixedClienteVenta & {
  pedidoId: string;
  fechaCreacion: number;
  usuarioId: string | null;
};

/**
 * Persiste un cliente en `empresas/{empresaId}/clientes`.
 */
export const crearClienteEnFirestore = async (
  datos: ApiFixedClienteVenta,
  pedidoId: string
): Promise<string | null> => {
  const userStore = userUserStore();
  const empresaId = userStore.empresa?.id;
  if (!empresaId) return null;

  const db = getFirestore();
  const payload: ClienteFirestoreDoc = {
    ...datos,
    pedidoId,
    fechaCreacion: Date.now(),
    usuarioId: userStore.user?.uid ?? null
  };

  try {
    const ref = await addDoc(
      collection(db, `empresas/${empresaId}/clientes`),
      payload
    );
    return ref.id;
  } catch (e) {
    console.error("Error al crear cliente en Firestore", e);
    return null;
  }
};
